<div>
    <p-table [value]="accounts" #cashDeskTable [paginator]="true" [lazy]="true" 
            [rows]="pageSize" [totalRecords]="totalElements"
            [rowsPerPageOptions]="[10,25,50]" (onLazyLoad)="loadAccounts($event)"
            [showCurrentPageReport]="true" class="currency-table" [tableStyle]="{'width': '100%'}">
        <ng-template pTemplate="header">
            <tr class="theader">
                <th id="glCode" width="14%" translate>accounts.gl_code</th>
                <th id="glAccountNumber" width="24%" translate>accounts.gl_name</th>
                <th id="accountName" width="28%" translate>accounts.name</th>
                <th id="acountNumber" width="22%" translate>accounts.number</th>
                <th id="currency" translate>common.currency</th>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr class="loan-account-item {{(selectedAccount && selectedAccount.number == item.number)?'selected-loan-account-item':''}}" (click)="composeAccounts(item)">
                <td>{{item.accountType.code}}</td>
                <td>
                    <div [pTooltip]="item.accountType.name?.length > 20 ? item.accountType.name : null" tooltipStyleClass="tooltip-class" tooltipPosition="bottom" class="ellipsis-text-overflow">
                        {{item.accountType.name}}
                    </div>
                </td>
                <td>
                    <div [pTooltip]="item.name?.length > 20 ? item.name : null" tooltipStyleClass="tooltip-class" tooltipPosition="bottom" class="ellipsis-text-overflow">
                        {{item.name}}
                    </div>
                </td>
                <td>{{item.number}}</td>
                <td>{{item.currency.isoCode}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
